import React from "react";
import { Button, Flex, ModalBody, IconButton } from "@chakra-ui/react";
import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import { ModalBox } from "../ModalBox";
import { FormInput } from "../FormInput";

export const StudentsInviteBox = ({
  isTeacher,
  students,
  inviteStudents,
  isOpen,
  onModalClose,
  isInviting,
  onNameChange,
  addNewStudent,
  removeChild,
}) => {
  return (
    <ModalBox
      title={isTeacher ? "Create students" : "Create childs"}
      isOpen={isOpen}
      onClose={onModalClose}
      modalProps={{
        closeOnOverlayClick: false,
        scrollBehavior: "inside",
      }}
    >
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            inviteStudents([...students]);
          }}
        >
          {React.Children.toArray(
            students.map((student, index) => (
              <Flex
                style={{ ...(index > 0 ? { alignItems: "flex-end" } : {}) }}
              >
                <FormInput
                  label="First name"
                  name="firstName"
                  type="text"
                  placeholder=""
                  inputOnChange={(e) => onNameChange(e, student.id)}
                  value={student.firstName}
                  formProps={{
                    isRequired: true,
                    isDisabled: isInviting,
                    width: index > 0 ? "45%" : "50%",
                  }}
                  padding="0 10px 20px 0"
                />
                <FormInput
                  label="Last name"
                  name="lastName"
                  type="text"
                  placeholder=""
                  inputOnChange={(e) => onNameChange(e, student.id)}
                  value={student.lastName}
                  formProps={{
                    isRequired: true,
                    isDisabled: isInviting,
                    width: index > 0 ? "45%" : "50%",
                  }}
                  padding="0 0 20px"
                />
                {index > 0 && (
                  <IconButton
                    variant="ghost"
                    colorScheme="red"
                    aria-label="remove child"
                    onClick={() => removeChild(student.id)}
                    fontSize="20px"
                    margin="0 0 20px 10px"
                    disabled={isInviting}
                    icon={<DeleteIcon />}
                  />
                )}
              </Flex>
            ))
          )}
          <Button
            leftIcon={<AddIcon size="16px" />}
            colorScheme="brand"
            variant="ghost"
            disabled={isInviting}
            onClick={addNewStudent}
          >
            Add new
          </Button>
          <Flex justifyContent="flex-end" width="100%" mb={2}>
            <Button
              colorScheme="brand"
              _hover={{
                bg: "blue.500",
              }}
              mr={3}
              type="submit"
              isLoading={isInviting}
              loadingText="Creating"
            >
              Create
            </Button>
            <Button onClick={onModalClose} disabled={isInviting}>
              close
            </Button>
          </Flex>
        </form>
      </ModalBody>
    </ModalBox>
  );
};
